var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.disabled}},[_c('i',{staticClass:"fas fa-globe-americas mr-2"}),_c('translate',[_vm._v("Translate with Google")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }